export default [{
  title: 'العربية',
  lang: 'ar'
}, {
  title: 'English',
  lang: 'en'
}]